import { useTheme } from "next-themes"
import { Toaster as Sonner, toast } from "sonner"

const Toaster = ({
  ...props
}) => {
  const { theme = "system" } = useTheme()

  return (
    <Sonner
      theme={theme}
      className="toaster group"
      toastOptions={{
        classNames: {
          toast:
            "group toast group-[.toaster]:bg-slate-800 group-[.toaster]:text-slate-50 group-[.toaster]:border-slate-700 group-[.toaster]:shadow-lg group-[.toaster]:rounded-lg",
          description: "group-[.toast]:text-slate-400",
          actionButton:
            "group-[.toast]:bg-teal-600 group-[.toast]:text-white",
          cancelButton:
            "group-[.toast]:bg-slate-700 group-[.toast]:text-slate-300",
          success: "group-[.toaster]:bg-slate-800 group-[.toaster]:text-emerald-400",
          error: "group-[.toaster]:bg-slate-800 group-[.toaster]:text-red-400",
          info: "group-[.toaster]:bg-slate-800 group-[.toaster]:text-blue-400",
        },
      }}
      {...props} />
  );
}

export { Toaster, toast }
